import C from "classnames";
import { Button } from "primereact/button";

// Styles
import S from "./_styles.module.scss";

const PanelToggleButton = ({
  isPanelOpen,
  onToggleClick,
  floating = false,
  title,
}: {
  isPanelOpen: boolean;
  onToggleClick: () => void;
  floating?: boolean;
  title?: string;
}) => {
  const toggleButtonIcon = isPanelOpen ? "pi pi-sj-caret-down" : "pi pi-sj-caret-up";
  const panelName = title ? `${title} panel` : "panel";

  return (
    <Button
      outlined
      size="small"
      className={C(S.drawerToggleButton, { ["float-right z-10 top-1.5 right-1.5"]: floating })}
      icon={toggleButtonIcon}
      text
      aria-label={isPanelOpen ? `Collapse ${panelName}` : `Expand ${panelName}`}
      aria-expanded={isPanelOpen}
      onClick={onToggleClick}
    />
  );
};

export default PanelToggleButton;
